"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FALSE = FALSE;
exports.TRUE = TRUE;
exports.VOID = VOID;
exports.memoizeOne = memoizeOne;
exports.toPromise = toPromise;

var _array = require("./array.js");

/**
 * @module ol/functions
 */

/**
 * Always returns true.
 * @return {boolean} true.
 */
function TRUE() {
  return true;
}
/**
 * Always returns false.
 * @return {boolean} false.
 */


function FALSE() {
  return false;
}
/**
 * A reusable function, used e.g. as a default for callbacks.
 *
 * @return {void} Nothing.
 */


function VOID() {}
/**
 * Wrap a function in another function that remembers the last return.  If the
 * returned function is called twice in a row with the same arguments and the same
 * this object, it will return the value from the first call in the second call.
 *
 * @param {function(...any): ReturnType} fn The function to memoize.
 * @return {function(...any): ReturnType} The memoized function.
 * @template ReturnType
 */


function memoizeOne(fn) {
  var called = false;
  /** @type {ReturnType} */

  var lastResult;
  /** @type {Array<any>} */

  var lastArgs;
  var lastThis;
  return function () {
    var nextArgs = Array.prototype.slice.call(arguments);

    if (!called || this !== lastThis || !(0, _array.equals)(nextArgs, lastArgs)) {
      called = true;
      lastThis = this;
      lastArgs = nextArgs;
      lastResult = fn.apply(this, arguments);
    }

    return lastResult;
  };
}
/**
 * @template T
 * @param {function(): (T | Promise<T>)} getter A function that returns a value or a promise for a value.
 * @return {Promise<T>} A promise for the value.
 */


function toPromise(getter) {
  function promiseGetter() {
    var value;

    try {
      value = getter();
    } catch (err) {
      return Promise.reject(err);
    }

    if (value instanceof Promise) {
      return value;
    }

    return Promise.resolve(value);
  }

  return promiseGetter();
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7QUFJQTs7QUFKQTs7OztBQU1BOzs7O0FBSU0sU0FBVUEsSUFBVixHQUFjO0VBQ2xCLE9BQU8sSUFBUDtBQUNEO0FBRUQ7Ozs7OztBQUlNLFNBQVVDLEtBQVYsR0FBZTtFQUNuQixPQUFPLEtBQVA7QUFDRDtBQUVEOzs7Ozs7O0FBS00sU0FBVUMsSUFBVixHQUFjLENBQUs7QUFFekI7Ozs7Ozs7Ozs7O0FBU00sU0FBVUMsVUFBVixDQUFxQkMsRUFBckIsRUFBdUI7RUFDM0IsSUFBSUMsTUFBTSxHQUFHLEtBQWI7RUFFQTs7RUFDQSxJQUFJQyxVQUFKO0VBRUE7O0VBQ0EsSUFBSUMsUUFBSjtFQUVBLElBQUlDLFFBQUo7RUFFQSxPQUFPO0lBQ0wsSUFBTUMsUUFBUSxHQUFHQyxLQUFLLENBQUNDLFNBQU4sQ0FBZ0JDLEtBQWhCLENBQXNCQyxJQUF0QixDQUEyQkMsU0FBM0IsQ0FBakI7O0lBQ0EsSUFBSSxDQUFDVCxNQUFELElBQVcsU0FBU0csUUFBcEIsSUFBZ0MsQ0FBQyxtQkFBWUMsUUFBWixFQUFzQkYsUUFBdEIsQ0FBckMsRUFBc0U7TUFDcEVGLE1BQU0sR0FBRyxJQUFUO01BQ0FHLFFBQVEsR0FBRyxJQUFYO01BQ0FELFFBQVEsR0FBR0UsUUFBWDtNQUNBSCxVQUFVLEdBQUdGLEVBQUUsQ0FBQ1csS0FBSCxDQUFTLElBQVQsRUFBZUQsU0FBZixDQUFiO0lBQ0Q7O0lBQ0QsT0FBT1IsVUFBUDtFQUNELENBVEQ7QUFVRDtBQUVEOzs7Ozs7O0FBS00sU0FBVVUsU0FBVixDQUFvQkMsTUFBcEIsRUFBMEI7RUFDOUIsU0FBU0MsYUFBVCxHQUFzQjtJQUNwQixJQUFJQyxLQUFKOztJQUNBLElBQUk7TUFDRkEsS0FBSyxHQUFHRixNQUFNLEVBQWQ7SUFDRCxDQUZELENBRUUsT0FBT0csR0FBUCxFQUFZO01BQ1osT0FBT0MsT0FBTyxDQUFDQyxNQUFSLENBQWVGLEdBQWYsQ0FBUDtJQUNEOztJQUNELElBQUlELEtBQUssWUFBWUUsT0FBckIsRUFBOEI7TUFDNUIsT0FBT0YsS0FBUDtJQUNEOztJQUNELE9BQU9FLE9BQU8sQ0FBQ0UsT0FBUixDQUFnQkosS0FBaEIsQ0FBUDtFQUNEOztFQUNELE9BQU9ELGFBQWEsRUFBcEI7QUFDRCIsIm5hbWVzIjpbIlRSVUUiLCJGQUxTRSIsIlZPSUQiLCJtZW1vaXplT25lIiwiZm4iLCJjYWxsZWQiLCJsYXN0UmVzdWx0IiwibGFzdEFyZ3MiLCJsYXN0VGhpcyIsIm5leHRBcmdzIiwiQXJyYXkiLCJwcm90b3R5cGUiLCJzbGljZSIsImNhbGwiLCJhcmd1bWVudHMiLCJhcHBseSIsInRvUHJvbWlzZSIsImdldHRlciIsInByb21pc2VHZXR0ZXIiLCJ2YWx1ZSIsImVyciIsIlByb21pc2UiLCJyZWplY3QiLCJyZXNvbHZlIl0sInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbInNyYy9mdW5jdGlvbnMuanMiXSwic291cmNlc0NvbnRlbnQiOltudWxsXX0=